import { all, fork } from 'redux-saga/effects'

import account from './Account/sagas'
import analytics from './Analytics/sagas'
import app from './App/sagas'
import auth from './Auth/sagas'
import balance from './Balance/sagas'
import config from './Config/sagas'
import currencies from './Currencies/sagas'
import eligibility from './Eligibility/sagas'
import apiKey from './Form/ApiKey/sagas'
import changeEmail from './Form/ChangeEmail/sagas'
import changePassword from './Form/ChangePassword/sagas'
import deposit from './Form/Deposit/sagas'
import forgotPassword from './Form/ForgotPassword/sagas'
import preferences from './Form/Preferences/sagas'
import profile from './Form/Profile/sagas'
import requestHistory from './Form/RequestHistory/sagas'
import form from './Form/sagas'
import signup from './Form/Signup/sagas'
import ticket from './Form/Ticket/sagas'
import tierTwo from './Form/TierTwo/Sagas'
import twoFactor from './Form/TwoFactor/Sagas'
import whitelistAddress from './Form/WhitelistAddress/Sagas'
import withdrawal from './Form/Withdrawal/sagas'
import historical from './Historical/sagas'
import instrument from './Instrument/sagas'
import margin from './Margin/sagas'
import order from './Order/sagas'
import payments from './Payments/sagas'
import price from './Price/sagas'
import referral from './Referral/sagas'
import socket from './Socket/sagas'
import ticker from './Ticker/sagas'
import trades from './Trades/sagas'
import walletLink from './WalletLink/sagas'

const rootSaga = function* () {
  performance.mark('sagas:start')
  yield all(
    [
      account,
      analytics,
      apiKey,
      app,
      auth,
      balance,
      config,
      changeEmail,
      currencies,
      changePassword,
      deposit,
      eligibility,
      preferences,
      form,
      forgotPassword,
      requestHistory,
      ticket,
      tierTwo,
      twoFactor,
      historical,
      instrument,
      margin,
      order,
      payments,
      price,
      profile,
      referral,
      signup,
      socket,
      ticker,
      trades,
      walletLink,
      withdrawal,
      whitelistAddress
    ].map(fork)
  )
}

export default rootSaga
